import { createModel } from '@rematch/core';
import { AppDispatch } from '../../types/store';
import { fetchTimeslots } from '../../api/timeslot';
import { DayTimeSlot, TimeSlot, TimeSlotRequest } from '../../api/models/timeslot';
import { LatLng } from '../../api/models/locations';
import { TIMESLOT_MAX_DAYS } from '../../utils/constants';

export type TimeSlotsByDate = {
  [key: string]: TimeSlot[];
};

export type TimeslotsStore = {
  isTimeSlotsFetching: boolean;
  timeSlotsByDate: TimeSlotsByDate;
  isTimeSlotsFetchingError?: boolean;
};

export type ModalsReducers = {
  setTimeslots: (timeslots: DayTimeSlot[]) => TimeslotsStore;
  setTimeslotsFetchingError: (isError: boolean) => TimeslotsStore;
  setIsTimeSlotsFetching: (isFetching: boolean) => TimeslotsStore;
};

export type TimeslotsDispatch = ModalsReducers & {
  fetchTimeslots: (dropOffCoordinate: LatLng) => Promise<void>;
};

const initialState: TimeslotsStore = {
  timeSlotsByDate: {},
  isTimeSlotsFetching: true,
  isTimeSlotsFetchingError: undefined
};

export const timeslots = createModel({
  //@ts-ignore
  effects: (dispatch: AppDispatch) => ({
    async fetchTimeslots(dropOffCoordinate: LatLng) {
      const { lat, lng } = dropOffCoordinate;
      const timeslotRequest: TimeSlotRequest = {
        maxDays: TIMESLOT_MAX_DAYS,
        dropoff: {
          coordinate: { latitude: lat, longitude: lng }
        }
      };
      dispatch.timeslots.setIsTimeSlotsFetching(true);
      const { timeslots } = await fetchTimeslots(timeslotRequest);
      dispatch.timeslots.setTimeslots(timeslots);
      dispatch.timeslots.setIsTimeSlotsFetching(false);
      return timeslots;
    }
  }),
  reducers: {
    setTimeslots(state: TimeslotsStore, timeslots: DayTimeSlot[]): TimeslotsStore {
      const newTimeslotsByDate: TimeSlotsByDate = timeslots.reduce((newStore, dayTimeSlot) => {
        const { date, slots } = dayTimeSlot;
        newStore[date] = slots;
        return newStore;
      }, {} as TimeSlotsByDate);
      return { ...state, timeSlotsByDate: newTimeslotsByDate };
    },
    setIsTimeSlotsFetching(state: TimeslotsStore, isFetching: boolean): TimeslotsStore {
      return { ...state, isTimeSlotsFetching: isFetching };
    }
  },
  state: initialState
});
